import { FC } from 'react'
import { Row, Col, Text, CardLink, Image } from '@/client/components'
import * as S from './styles'
import { DownloadProps } from '../types'

export const Download: FC<DownloadProps> = ({ download: { title, logo, documents } }) => (
  <>
    <S.Download>
      <Row>
        <Col xs={12}>
          <Text family='heading' size='xxlg' weight='bold' margin='0 0 2rem' align='center'>
            {title}
          </Text>
        </Col>
      </Row>

      <Row>
        <Col xs={12} xl={9}>
          <Text family='heading' size='lg' weight='bold' margin='0 0 2rem'>
            {logo?.title}
          </Text>

          <S.Logos>
            {logo?.logos?.map(({ type, title: logoTitle, image, downloads }) => (
              <S.LogoCard key={logoTitle}>
                <S.WrapperImageLogo dark={type === 'dark'}>
                  <Image
                    src={image.url}
                    width={image.width}
                    height={image.height}
                    alt={image.alt || logoTitle}
                    style={{ display: 'block', width: '100%', height: 'auto' }}
                  />
                </S.WrapperImageLogo>

                <Text weight='bold' margin='1.5rem'>
                  {logoTitle}
                </Text>

                <S.AnchorList>
                  {downloads.map(({ format, link }) => (
                    <S.Anchor key={format} href={link} target='_blank'>
                      {format}
                    </S.Anchor>
                  ))}
                </S.AnchorList>
              </S.LogoCard>
            ))}
          </S.Logos>
        </Col>

        <Col xs={12} xl={3}>
          <Text family='heading' size='lg' weight='bold' margin='0 0 2rem'>
            {documents?.title}
          </Text>

          <nav>
            {documents?.list?.map(({ link, title, subtitle }) => (
              <CardLink key={title} link={link} icon='pdf' title={title} subtitle={subtitle} />
            ))}
          </nav>
        </Col>
      </Row>
    </S.Download>
  </>
)
